'use client'

import { ButtonIconTransparent } from '@fukku/button/Icon/Transparent'
import { IconEyeoffL } from 'icons/components/IconEyeoffL'
import { IconEyeonL } from 'icons/components/IconEyeonL'
import { useState } from 'react'

import { Input } from '../Input'
import { type InputPasswordProps, InputType } from './types'

import fukkuStyle from 'fukku/styles/classes.module.scss'
import styles from './InputPassword.module.scss'

export const InputPassword = ({
	ariaLabelShow,
	ariaLabelHide,
	id,
	...inputProps
}: InputPasswordProps): React.ReactNode => {
	const [showPassword, setShowPassword] = useState(false)
	function handleClick() {
		setShowPassword((prevShowPassword) => !prevShowPassword)
	}

	return (
		<Input
			{...inputProps}
			id={id}
			type={showPassword ? InputType.TEXT : InputType.PASSWORD}
		>
			<ButtonIconTransparent
				className={styles.iconEye}
				onClick={handleClick}
				aria-live='polite'
			>
				{showPassword ? (
					<>
						<IconEyeoffL height={24} width={24} />
						<span className={fukkuStyle.srOnly}>{ariaLabelHide}</span>
					</>
				) : (
					<>
						<IconEyeonL height={24} width={24} />
						<span className={fukkuStyle.srOnly}>{ariaLabelShow}</span>
					</>
				)}
			</ButtonIconTransparent>
		</Input>
	)
}
